export const isEditProjectAllowed = (frontend_controller) => {
    return frontend_controller['EditProject'] === 1;
};

export const isUserChangesAllowed = (frontend_controller) => {
    return frontend_controller['user_change'] === 1;
};

export const isDeletePoAllowed = (frontend_controller) => {
    return frontend_controller['deletePo'] === 1;
};

export const isViewPoAllowed = (frontend_controller) => {
    return frontend_controller['viewPO'] === 1;
};

export const isViewWithdrawlsAllowed = (frontend_controller) => {
    return frontend_controller['ViewWithdrawls'] === 1;
};

export const isViewCLIncentiveAllowed = (frontend_controller) => {
    return frontend_controller['ViewCLIncentive'] === 1;
};

export const isApprovePaymentAllowed = (frontend_controller) => {
    return frontend_controller['PaymentApprovar'] === 1;
};

export const isDownloadStatementAllowed = (frontend_controller) => {
    return frontend_controller['downloadStatement'] === 1;
};

export const isRefreshBankOpenBalanceAllowed = (frontend_controller) => {
    return frontend_controller['RefreshBankOpenBalance'] === 1;
};

export const isEditAllowedInAdditonalPayament = (frontend_controller) => {
    return frontend_controller.EditPrice === 1;
};

export const isUserOnboarded = (status) => {
    return status >= 2.5;
};

export const isAssignAllowed = (frontend_controller) => {
    return frontend_controller.Assignment === 1;
};

export const isSignOffApproveAllowed = (frontend_controller) => {
    return frontend_controller.SignOff === 1;
};

export const isHelpAllowed = (frontend_controller) => {
    return frontend_controller['HelpAccess'] === 1;
};

export const isTicketAdditionAllowed = (frontend_controller) => {
    return frontend_controller['TicketAddition'] === 1;
};

export const isToShowCustomerPaymentDetails = (frontend_controller) => {
    return frontend_controller['CustomerPaymentDetails'] === 1;
};

export const isToShowCustomerBillingTab = (frontend_controller) => {
    return frontend_controller['CustomerBilling'] === 1;
}

export const isVerifyUserAllowed = (frontend_controller) => {
    return frontend_controller['verify_user'] === 1;
}

export const isToShowUserIncomeDetails = (frontend_controller) => {
    return frontend_controller['show_income_details'] === 1;
}

export const isDirectBankTransferAllowed = (frontend_controller) => {
    return frontend_controller['DirectBankTransfer'] === 1;
}

export const hasAdditionalPriceAccess = (frontend_controller) => {
    return frontend_controller['AdditionalPriceAccess'] === 1;
};

export const isEditChecklistAllowed = (frontend_controller) => {
    return frontend_controller['EditChecklist'] === 1;
}

export const isEditCategoryAllowed = (frontend_controller) => {
    return frontend_controller['EditCategory'] === 1;
}

export const isChangePlanAllowed = (frontend_controller) => {
    return frontend_controller['changePlan'] === 1;
}

export const isAddSlaAllowed = (frontend_controller) => {
    return frontend_controller['addSLA'] === 1;
}

export const isDownloadOfflineTransactionAllowed = (frontend_controller) => {
    return frontend_controller['DownloadOfflineTransaction'] === 1;
}

export const isPancardLinkUpdateAllowed = (frontend_controller) => {
    return frontend_controller['PancardLinkUpdate'] === 1;
}

export const isAssetActionsAllowed = (frontend_controller) => {
    return frontend_controller['AssetActions'] === 1;
}



export const Actions = {
    CREATE_PROJECT: 'CREATE_PROJECT',
    CREATE_TICKET: 'CREATE_TICKET',
    CREATE_TEAM: 'CREATE_TEAM',
    INVITE_MEMBER: 'INVITE_MEMBER',
    CHANGE_USER_ROLES: 'CHANGE_USER_ROLES',
    CREATE_ROLE: 'CREATE_ROLE',
    VIEW_PERMISSIONS: 'VIEW_PERMISSIONS',
    VERIFY_USERS: 'VERIFY_USERS',
    VIEW_UNMASKED_DATA: 'VIEW_UNMASKED_DATA',
    VIEW_WITHDRAWALS: 'VIEW_WITHDRAWALS',
    VIEW_PO: 'VIEW_PO',
    PAY_PO: 'PAY_PO',
    MODIFY_PO: 'MODIFY_PO',
    PROVIDE_HELP: 'PROVIDE_HELP',
    REQUEST_HELP: 'REQUEST_HELP',
    MANAGE_OTHER_ORGS: 'MANAGE_OTHER_ORGS',
    NEW_TICKET_TAB: 'NEW_TICKET_TAB',
    TODAY_STATUS_TAB: 'TODAY_STATUS_TAB',
    CREATE_INVENTORY_ASSET: 'CREATE_INVENTORY_ASSET',
    CREATE_INVENTORY_LOCATION: 'CREATE_INVENTORY_LOCATION',
    LOG_OFFLINE_TRANSACTIONS: 'LOG_OFFLINE_TRANSACTIONS',
    INCENTIVE_PERMISSION: 'INCENTIVE_PERMISSION',
    APPROVE_TICKET_AMOUNT: 'APPROVE_TICKET_AMOUNT',
    UPDATE_USER_BANK: 'UPDATE_USER_BANK',
    BULK_REMOVE_CLUSTER: 'BULK_REMOVE_CLUSTER',
    SIGNOFF_UNLOCK: 'SIGNOFF_UNLOCK',
    PLACE_OUTBOUND_CALLS: 'PLACE_OUTBOUND_CALLS',
    MAKE_SETTLEMENTS: 'MAKE_SETTLEMENTS',
    ACTIVATE_PROJECTS: 'ACTIVATE_PROJECTS',
    VIEW_CUSTOMER_BILLING: 'VIEW_CUSTOMER_BILLING',
    VIEW_TICKET_BUDGET: 'VIEW_TICKET_BUDGET',
    VIEW_USER_CALENDAR: 'VIEW_USER_CALENDAR',
    UPDATE_USER_CALENDAR: 'UPDATE_USER_CALENDAR'
}


export const isAddNewProjectAllowed = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.CREATE_PROJECT && action.allowed);
    }
    return false;
}

export const isCreateTicketAllowed = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.CREATE_TICKET && action.allowed);
    }
    return false;
}

export const isCreateTeamAllowed = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.CREATE_TEAM && action.allowed);
    }
    return false;
}

export const isSendInvitesAllowed = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.INVITE_MEMBER && action.allowed);
    }
    return false;
}

export const isChangeUserRolesAllowed = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.CHANGE_USER_ROLES && action.allowed);
    }
    return false;
}

export const isCreateRoleAllowed = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.CREATE_ROLE && action.allowed);
    }
    return false;
}

export const isViewPermissionsAllowed = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.VIEW_PERMISSIONS && action.allowed);
    }
    return false;
}

export const isVerifyUsersAllowed = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.VERIFY_USERS && action.allowed);
    }
    return false;
}

export const isViewUnmaskedDataAllowed = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.VIEW_UNMASKED_DATA && action.allowed);
    }
    return false;
}

export const isViewWithdrawalsAllowed = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.VIEW_WITHDRAWALS && action.allowed);
    }
    return false;
}

export const isViewPOAllowed = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.VIEW_PO && action.allowed);
    }
    return false;
}

export const isPayPOAllowed = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.PAY_PO && action.allowed);
    }
    return false;
}

export const isModifyPOAllowed = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.MODIFY_PO && action.allowed);
    }
    return false;
}

export const isProvideHelpAllowed = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.PROVIDE_HELP && action.allowed);
    }
    return false;
}

export const isRequestHelpAllowed = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.REQUEST_HELP && action.allowed);
    }
    return false;
};

export const canManageOtherOrgs = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.MANAGE_OTHER_ORGS && action.allowed);
    }
    return false;
}



export const canViewTodayStatusTab = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.TODAY_STATUS_TAB && action.allowed);
    }
    return false;
}


export const canViewNewTicketTab = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.NEW_TICKET_TAB && action.allowed);
    }
    return false;
}


export const canCreateInventoryAsset = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.CREATE_INVENTORY_ASSET && action.allowed);
    }
    return false;
}

export const canCreateInventoryLocation = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.CREATE_INVENTORY_LOCATION && action.allowed);
    }
    return false;
}

export const canLogOfflineTransactions = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.LOG_OFFLINE_TRANSACTIONS && action.allowed);
    }
    return false;
}


export const canViewIncentiveCard = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.INCENTIVE_PERMISSION && action.allowed);
    }
    return false;
}

export const canApproveTicketAmount = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.APPROVE_TICKET_AMOUNT && action.allowed);
    }
    return false;
}

export const canUpdateUserBankDetails = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.UPDATE_USER_BANK && action.allowed);
    }
    return false;
}

export const canBulkRemoveCluster = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.BULK_REMOVE_CLUSTER && action.allowed);
    }
    return false;
}

export const canUnlockSignOff = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.SIGNOFF_UNLOCK && action.allowed);
    }
    return false;
}


export const canPlaceOutboundCalls = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.PLACE_OUTBOUND_CALLS && action.allowed);
    }
    return false;
}

export const canMakeSettlement = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.MAKE_SETTLEMENTS && action.allowed);
    }
    return false;
}

export const canActivateProjects = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.ACTIVATE_PROJECTS && action.allowed);
    }
    return false;
}

export const canViewProjectBilling = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.VIEW_CUSTOMER_BILLING && action.allowed);
    }
    return false;
}


export const canViewTicketBudget = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.VIEW_TICKET_BUDGET && action.allowed);
    }
    return false;
}

export const canInviteCustomerUser = (roles) => {
    if (!roles || roles.length === 0) {
        return false;
    }
    return roles.some((role) => role.can_invite_customer_users === true);
}

export const canViewUserCalender = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.VIEW_USER_CALENDAR && action.allowed);
    }
    return false;
}


export const canUpdateUserCalender = (actions) => {
    if (Array.isArray(actions)) {
        return actions.find(action => action.action === Actions.UPDATE_USER_CALENDAR && action.allowed);
    }
    return false;
}
